// @flow
import { takeEvery, call, select, put, spawn } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';
import {
  PRODUCTS,
  receiveToggledFavorite,
} from 'pages/MyAccount/services/actions/productsActions';
import type { RequestToggleFavoritesAction } from 'pages/MyAccount/services/actions/productsActions';
import { updateFavorite as _updateFavorite } from 'pages/MyAccount/services/api/products';
import { segmentEnum, track } from 'pages/MyAccount/utils/segment';
import { selectTrackingData } from 'pages/MyAccount/selectors/trackingSelector';

const { REQUEST_TOGGLE_FAVORITE } = PRODUCTS;

// WATCHER SAGAS
export function* watchUpdateFavorites(): Saga<void> {
  yield takeEvery(REQUEST_TOGGLE_FAVORITE, updateFavorite);
}

// WORKER SAGAS
function* updateFavorite(action: RequestToggleFavoritesAction): Saga<void> {
  const { productId, isLike } = action;
  const campaignId = yield select((state) => state.campaignState.campaignId);
  const toggledFavoriteResponse = yield call(
    _updateFavorite,
    campaignId,
    productId,
    isLike
  );

  yield put(receiveToggledFavorite(toggledFavoriteResponse));

  yield spawn(handleFavoriteTracking, action);
}

function* handleFavoriteTracking(
  action: RequestToggleFavoritesAction
): Saga<void> {
  const {
    productId,
    variantId,
    buttonLocation,
    isLike,
    selectedCategoryId,
  } = action;

  const trackingDataFromState = yield select((state) =>
    selectTrackingData(state, { productId, variantId, selectedCategoryId })
  );

  const trackingData = {
    ...trackingDataFromState,
    experience: buttonLocation,
  };

  const eventName = isLike
    ? segmentEnum.productFavorited
    : segmentEnum.productUnfavorited;

  track(eventName, trackingData);
}
